import { isEmptyObject } from '@/lib/utils/is'
import qs from '@/lib/utils/qs'

/** simple fetch to get application/json */
export default function Fetcher({ baseUrl, token }) {
  return async function(endpoint, { url, query, config } = {}) {
    let resourceUrl = null

    try {
      if (!endpoint) {
        throw new Error('`endpoint` is not defined')
      }

      if (baseUrl && endpoint) {
        resourceUrl = new URL(endpoint, baseUrl)
      } else {
        resourceUrl = new URL(url)
      }

      if(!resourceUrl) {
        throw new Error('`resourceUrl` is undefined')
      }

      if (!isEmptyObject(query)) {
        resourceUrl.search = qs(query).toString()
      }

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-KEY': process.env.NEXT_PUBLIC_API_KEY,
      }

      if (token) {
        headers['Authorization'] = `Bearer ${token}`
      }

      const res = await fetch(resourceUrl, {
        method: 'GET',
        headers,
        ...config,
      })
      // console.log('[fetcher] response', res)

      if (!res?.ok) {
        const error = await res.json();
        // console.log('[fetcher] error', error)

        throw {
          success: false,
          message: error?.message || error?.error || res?.statusText || 'Unknown error',
          errorCode: error.code || res?.status,
        }
      }

      return res.json()
    } catch (e) {
      // console.error('[fetcher]', e)
      throw e
    }
  }
}
